import React from "react";

function useAutoLoadMore({
  enabled = true,
  hasMore = false,
  isLoadingMore = false,
  onLoadMore,
  root = null,
  rootMargin = "200px 0px",
  threshold = 0,
}) {
  const targetRef = React.useRef(null);
  const requestLockedRef = React.useRef(false);

  React.useEffect(() => {
    if (!isLoadingMore) {
      requestLockedRef.current = false;
    }
  }, [isLoadingMore]);

  React.useEffect(() => {
    if (!enabled || !hasMore || typeof onLoadMore !== "function") {
      return undefined;
    }

    const node = targetRef.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const firstEntry = entries[0];
        if (!firstEntry?.isIntersecting) {
          return;
        }

        if (requestLockedRef.current || isLoadingMore || !hasMore) {
          return;
        }

        requestLockedRef.current = true;
        onLoadMore();
      },
      {
        root,
        rootMargin,
        threshold,
      }
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [enabled, hasMore, isLoadingMore, onLoadMore, root, rootMargin, threshold]);

  return targetRef;
}

export default useAutoLoadMore;